import { statsItems } from "@/mocks/home";
import Reveal from "./Reveal";

export default function StatsStrip() {
  return (
    <section className="w-full border-b border-background-200 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <div className="grid grid-cols-2 gap-x-4 gap-y-8 lg:grid-cols-4">
          {statsItems.map((item, index) => (
            <Reveal key={item.label} delay={index * 70}>
              <div className="flex flex-col border-secondary-300 lg:border-l lg:pl-6 lg:first:border-l-0 lg:first:pl-0">
                <div className="flex items-baseline gap-1">
                  <span className="font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                    {item.value}
                  </span>
                  <span className="font-label text-sm text-primary-600">{item.unit}</span>
                </div>
                <span className="mt-2 font-body text-sm text-foreground-600">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}